import { useEffect } from "react";
import { development } from "../config";
import { SyncManager } from "./manager";
import type { FetchDataArgs } from "./types";

const minWork = 0;
const maxWork = 20;
const minDurationPerWork = 100;
const maxDurationPerWork = 3000;
const errorProbability = 0.5;

async function fetchData({ observer }: FetchDataArgs) {
  const work = minWork + Math.floor(Math.random() * (maxWork - minWork));
  observer.setWork(work);

  const errorAt =
    Math.random() < errorProbability ? Math.floor(Math.random() * work) : -1;

  for (let i = 0; i < work; i++) {
    if (observer.canceled) return;
    const delay =
      minDurationPerWork +
      Math.random() * (maxDurationPerWork - minDurationPerWork);
    await new Promise((resolve) => setTimeout(resolve, delay));

    if (i === errorAt) {
      throw new Error("Test Error");
    } else {
      observer.workCompleted();
    }
  }
}

export function useTestSyncModules(manager: SyncManager) {
  useEffect(() => {
    if (development) {
      manager.registerModule({
        id: "test1",
        i18nKey: "sync:tasks.test1",
        defaultOptions: { schedule: { type: "manual" } },
        fetchData,
      });

      manager.registerModule({
        id: "test2",
        i18nKey: "sync:tasks.test2",
        defaultOptions: {
          schedule: { type: "periodic", interval: 60 * 1000 },
          requiredNetworkStatus: ["wifi"],
        },
        fetchData,
      });

      manager.registerModule({
        id: "test3",
        i18nKey: "sync:tasks.test3",
        defaultOptions: { schedule: { type: "daily", hour: 12, minute: 0 } },
        fetchData,
      });
    }
  }, [manager]);
}
